import { getUserFullName } from '../../../../utils/user'

function getBirdviewRequestAssignee(request) {
  const assignee = request.assignees?.[0]

  return assignee ? getUserFullName(assignee) : undefined
}

// TODO `hint` (needs input / no provider / stale Nd, BR-DASH-06) waits for the
// backend flags; BirdviewRowDeadline shows it in place of the deadline.
export function toBirdviewRequestItem(request) {
  return {
    address: request.building?.title,
    assignee: getBirdviewRequestAssignee(request),
    canEditAssignee: request.permissions?.can_edit_assignee,
    deadline: request.due_date,
    id: request.id,
    number: request.request_no,
    status: request.status,
    title: request.title,
    unread: request.unread,
  }
}
